// --- React & Redux
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useProductsActions } from '../../../../store/products/useProducts';
// --- UI Components
import { Drawer } from 'antd';
import { TabsContent } from './tabs';
// --- Styles
import './styles.scss';

/**
 * ProductDetailsDrawer Component
 *
 * This component renders a drawer that displays detailed information about a product.
 * It uses Redux to manage the state of the drawer (open/close) and the product details.
 *
 * @component
 * @returns {JSX.Element} The Product Details Drawer component.
 */
export const ProductDetailsDrawer = () => {
    const { isDetailsOpen, details } = useSelector((state) => state.products);
    const { updateProducts } = useProductsActions();

    const handleClose = useCallback(() => {
        updateProducts({ isDetailsOpen: false });
    }, [updateProducts]);

    return (
        <Drawer
            className="product-details-drawer"
            title="Product Details"
            width={750}
            placement="right"
            open={isDetailsOpen}
            onClose={handleClose}
            bodyStyle={{ paddingBottom: 80 }}
        >
            <TabsContent details={details} />
        </Drawer>
    );
};
